import req from "../http";

const configSetting = {
  // 取得 系統設定參數
  getSystemConfig(params) {
    return req("get", "/BasicInformation/showableconfig", params);
  },

  // 批次編輯 系統設定參數
  putSystemConfig(params) {
    return req("put", "/BasicInformation/config/batch", params);
  },
};

export default configSetting;